<template>
  <LinkWrapper
    :href="operatorLink"
    :class="classes.link"
    target="_blank"
    @click="handleClick"
    v-if="operatorLogo"
  >
    <img :src="operatorLogo" :class="classes.image" @load="effectTrigger" />
  </LinkWrapper>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { useLayoutEffect } from "@fresh8/vue-utils/src/dimensionSync";
import LinkWrapper from "./LinkWrapper.vue";
import {
  injectAdTag,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import { useAnalytics } from "../hooks/useAnalytics";

const useStyles = createUseStyles({
  link: {
    height: "100%",
    flex: 1,
    justifyContent: "flex-end"
  },
  image: {
    height: "100%",
    objectFit: "contain",
    maxHeight: "inherit",
    maxWidth: "inherit",
    display: "block"
  }
});

export default defineComponent({
  name: "OperatorLogo",
  components: {
    LinkWrapper
  },
  setup() {
    const classes = useStyles();
    const { operatorLogos } = injectBrand();
    const betData = injectBetData();
    const { operator } = injectAdTag();
    const effectTrigger = useLayoutEffect();
    const { handleClick } = useAnalytics({}, "Operator Logo");

    return {
      classes,
      operatorLogo: computed(() => {
        return (
          operator.value &&
          operatorLogos.value?.[operator.value.key]?.desktop.binary
        );
      }),
      operatorLink: computed(
        () =>
          betData?.links.value?.provider ||
          `https://links.fresh8.co?operator=${operator.value.key}`
      ),
      effectTrigger,
      handleClick
    };
  }
});
</script>

<style></style>
